import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomDropdown, CustomModal, InputText, SelectEmpresas } from '../../../components'
import * as PickHttp from '../../../services/api/https/picking/picking.http'
import { errorHandler } from '../../../services/util/error.service'
import { showMessageBox } from '../../../store/actions/system.actions'
import { PickingStatus } from '../../../constants/picking-status'
import {
  descricaoMantemSufixoFixo,
  getSufixoFixoDescricaoPicking,
} from '../../../services/util/picking-name.service'

// Tipos permitidos para Picking Reconferência
const PickingTypesReconferencia = [
  //{ value: 'Consolidado', label: 'Consolidado' },
  { value: 'PorCliente', label: 'Por Cliente' },
  //{ value: 'PorPallet', label: 'Por Pallet' },
]

function ModalPickingReconferencia({ data, show, onModalClose, onModalSave, dispatch }) {
  // Hooks
  const [state, setState] = useState(null)
  const { SemEntregasAssociadas } = PickingStatus
  const viewOnly = !!(data && data.viewOnly)
  // Descrição no padrão "... | {placa} - {motorista} - {data}": só o lado esquerdo do pipe é editável
  const sufixoFixoDescricao = getSufixoFixoDescricaoPicking(data && data.name)

  useEffect(() => {
    data && setState(data)
  }, [data])

  const onDescricaoChange = value => {
    if (!descricaoMantemSufixoFixo(value, sufixoFixoDescricao)) return
    onFormContentChange('name', value)
  }

  // Events
  const onFormContentChange = (name, value) => {
    setState(prevState => {
      if (name === 'company_id') {
        prevState.company_id = value.id
      } else {
        prevState[name] = value
      }
      return { ...prevState }
    })
  }

  const onBtnSalvarClicked = async () => {
    try {
      const { id, name, status, company_id, tp_id, type, referencia, observacao } = state

      // Validar tipo de separação
      if (!type || !PickingTypesReconferencia.find(t => t.value === type)) {
        dispatch(showMessageBox(null, 'Selecione um tipo de separação válido'))
        return
      }

      const pick = await PickHttp.savePickingReconferencia({
        id,
        name,
        status,
        company_id,
        tp_id,
        type,
        referencia: referencia ? referencia.trim() : null,
        observacao: observacao ? observacao.trim() : null,
      })
      onModalSave(pick)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  // Render
  return (
    <CustomModal header="Picking - Reconferência" isVisible={show} onClose={onModalClose}>
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Descrição :"
            marginTop={10}
            value={state ? state.name : ''}
            onChange={onDescricaoChange}
            disabled={viewOnly}
          />
          {sufixoFixoDescricao && !viewOnly && (
            <p style={{ margin: '6px 0 0 0', fontSize: '0.78rem', color: '#555' }}>
              Só é possível editar ou acrescentar informações à esquerda de "|"
            </p>
          )}
        </div>
        {state && (SemEntregasAssociadas.label === state.status || viewOnly) && (
          <>
            <div className="p-col-6">
              <SelectEmpresas
                companyId={state ? state.company_id : ''}
                onChange={value => onFormContentChange('company_id', value)}
                disabled={viewOnly}
              />
            </div>
            <div className="p-col-6">
              <CustomDropdown
                label="Tipo de Separação"
                options={PickingTypesReconferencia}
                value={state ? state.type : ''}
                onChange={value => onFormContentChange('type', value)}
                disabled={viewOnly}
              />
            </div>
          </>
        )}
        <div className="p-col-6">
          <InputText
            label="Referência :"
            marginTop={10}
            value={state ? (state.referencia || '') : ''}
            onChange={value => onFormContentChange('referencia', value)}
            disabled={viewOnly}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Observação :"
            marginTop={10}
            value={state ? (state.observacao || '') : ''}
            onChange={value => onFormContentChange('observacao', value)}
            disabled={viewOnly}
          />
        </div>
        {viewOnly && (
          <div className="p-col-12" style={{ marginTop: 10, color: '#c0392b', fontStyle: 'italic' }}>
            Obs: Este Picking NÃO pode ser editado pois seu Status é: {state && state.status}
          </div>
        )}
        {!viewOnly && (
          <div className="p-col-12">
            <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
          </div>
        )}
      </form>
    </CustomModal>
  )
}
export default connect()(ModalPickingReconferencia)
